<template>
  <!-- in IE, use a simple button with a title -->
  <button v-if="isIE" 
    :class="classes"
    :title="title"
    :style="style"
    @click="$emit('click', $event)"
    type="button">
    <slot></slot>
  </button>
  <!-- in modern browsers, use the vuetify tooltip and button components -->
  <v-tooltip bottom v-else-if="title">
    <template v-slot:activator="{on}">
      <v-btn 
        :style="style"
        :fab="fab"
        :class="classes"
        :text="text"
        :block="block"
        :icon="icon"
        :disabled="disabled"
        :color="btnColor"
        :x-small="xSmall"
        :small="small"
        :medium="medium"
        :large="large"
        :x-large="xLarge"
        @click="$emit('click', $event)"
        v-on="on">
        <slot></slot>
      </v-btn>
    </template>
    <span>{{title}}</span>
  </v-tooltip>
  <!-- in modern browsers, without a title, don't generate a tooltip -->
  <v-btn v-else
    :class="classes"
    :text="text"
    :block="block"
    :icon="icon"
    :disabled="disabled"
    :color="btnColor"
    :x-small="xSmall"
    :small="small"
    :medium="medium"
    :large="large"
    :x-large="xLarge"
    :fab="fab"
    @click="$emit('click', $event)">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    text: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: "" },
    btnClass:  { type: String, default: "" },
    btnColor: { type: String, default: "" },
    xSmall: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    xLarge: { type: Boolean, default: false },
    fab: {type: Boolean, default: false}
  },
  computed: {
    isIE() {
      return this.$store.getters.isIE;
    },
    classes() {
      let classes = [
        this.btnClass,
        this.isIE ? "ie-button" : "",
        this.isIE && this.block ? "ie-button-block" : "",
        this.isIE && this.icon ? "ie-button-icon" : "",
        this.isIE && this.xSmall ? "ie-button-xSmall" : "",
        this.isIE && this.small ? "ie-button-small" : "",
        this.isIE && this.medium ? "ie-button-medium" : "",
        this.isIE && this.large ? "ie-button-large" : "",
        this.isIE && this.xLarge ? "ie-button-xLarge" : ""
      ].filter(v => v).join(" ");
      return classes;
    },
    style() {
      if (this.btnColor){
        return `background-color: ${this.btnColor}; border-color: ${this.btnColor}`;
      }
      return "";
    }
  }
};
</script>